const API_URL =
  import.meta.env.MODE === "development"
    ? "http://localhost:8080"
    : import.meta.env.VITE_API_URL;

export async function deleteInterview(email, interviewId) {
  try {
    const res = await fetch(`${API_URL}/api/delete-interview`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, interviewId }),
    });

    if (!res.ok) {
      console.error("Delete failed with status:", res.status);
      const errorText = await res.text();
      console.error("Error response:", errorText);
      throw new Error(`Failed to delete interview: ${res.status} ${errorText}`);
    }

    return true;
  } catch (e) {
    console.error("Delete interview error:", e);
    throw e;
  }
}
